












































import { Component, Prop, Vue } from 'vue-property-decorator';
import Container from '@/components/atoms/Grid/Container.vue';
import FormLabel from '@/components/molecules/Typography/FormLabel.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import RefundConfigForm from '@/components/organisms/RefundConfigForm/RefundConfigForm.vue';
import { configFormDataFactory } from '@/views/Onboarding/helpers';
import { ConfigFormData } from '@/models/onboarding';
import AdminService from '@/api/AdminService';
import eventBus from '@/utils/eventBus';

@Component({
  components: {
    FilledButton,
    FormLabel,
    Container,
    Typography,
    RefundConfigForm
  }
})
export default class TwismWalletEditDate extends Vue {
  @Prop() business!: any;
  @Prop() tippyElementSelector!: string;

  service: AdminService = new AdminService();

  loading = false;

  formData: ConfigFormData = {
    ...configFormDataFactory(),
    value: Number(this.business.subscriptionSettingsDelayPeriod),
    state: {
      [Number(this.business.subscriptionSettingsDelayPeriod)]: true
    },
    type: 'default'
  };

  async confirm() {
    try {
      this.loading = true;
      await this.service.extendBillingDelayedPeriod(
        this.business.id,
        Number(this.formData.value || this.formData.customValue)
      );
      eventBus.$emit('reloadTwismWallet', true);
      this.closeModal();
    } finally {
      this.loading = false;
    }
  }

  handleChangeDateConfig(formData: ConfigFormData) {
    this.formData = formData;
  }

  closeModal() {
    const element = document.querySelector(this.tippyElementSelector);
    if (element) (element as any)._tippy.hide();
  }
}
